import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=be7efdb0&scoped=true&"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=be7efdb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7efdb0",
  null
  
)

export default component.exports